import React from "react";
import WorkCasePage from "../components/workcase/WorkCasePage";
import imgGetwet from "../assets/img/img-work-getwet.png";

function Getwet() {
  return (
    <WorkCasePage
      title="GetWet"
      heroImage={imgGetwet}
      heroAlt="GetWet — Electron Desktop App"
    >
      <p>
        Electron-Desktop-App, die daran erinnert, Pflanzen rechtzeitig zu gießen —
        mit lokaler Oberfläche, klarer Typografie und einem ruhigen, fokussierten UI.
      </p>
      <p>
        Umsetzung als Desktop-Anwendung (nicht klassische Website): Installation
        lokal, UI-States und Interaktionen sind auf den Schreibtisch-Workflow
        ausgelegt.
      </p>
    </WorkCasePage>
  );
}

export default Getwet;
